import { render, staticRenderFns } from "./FormControlTypeColor.vue?vue&type=template&id=1955c3f4&scoped=true"
import script from "./FormControlTypeColor.vue?vue&type=script&lang=js"
export * from "./FormControlTypeColor.vue?vue&type=script&lang=js"
import style0 from "./FormControlTypeColor.vue?vue&type=style&index=0&id=1955c3f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1955c3f4",
  null
  
)

export default component.exports